<template>
  <base-entities-list
    tag="specialist"
    :cardComponent="entityComponent"
    :innerTableHeaders="innerHeaders"
  ></base-entities-list>
</template>

<script>
import BaseEntitiesList from '../BaseEntitiesList';
import SiteSpecialistCard from './SiteSpecialistCard';

export default {
  components: {
    BaseEntitiesList
  },

  data() {
    return {
      entityComponent: SiteSpecialistCard,
      innerHeaders: [
        {
          text: 'ФИО',
          value: 'fullName'
        },
        {
          text: 'Должность',
          value: 'position'
        }
      ],
    }
  }
}
</script>